import { AssignmentLate } from '@mui/icons-material';
import { Alert, Box, Collapse } from '@mui/material';
import React from 'react';
import './index.scss';

export const NoDetailNotice: React.SFC<{ label: string }> = ({
    label
}) => {
    const [open, setOpen] = React.useState(true);
    return (
        <Box sx={{ width: '100%' }}>
            <Collapse in={open}>
                <Alert sx={{ m: 1, maxWidth: '380px', opacity: .8 }} onClose={() => setOpen(false)} severity="info" icon={<AssignmentLate />}>
                    No {label} for this material
                </Alert>
            </Collapse>
        </Box>
    );
}